export type SharedPartialInput = {
  id: number;
  slug: string;
  title: string;
  is_home?: boolean;
};

export type SharedPartialRow = {
  pageId: number;
  title: string;
  callName: string;
  path: string;
  slug: string;
};

export function callNameFromSlug(slug: string): string {
  return slug.trim().replace(/^_+/, "");
}

export function listSharedPartials(pages: SharedPartialInput[]): SharedPartialRow[] {
  return pages
    .filter((page) => page.slug.trim().startsWith("_"))
    .map((page) => {
      const slug = page.slug.trim();
      const callName = callNameFromSlug(slug);
      const title = page.title.trim() || callName;
      return { pageId: page.id, title, callName, path: `/${slug}`, slug };
    });
}
